import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const STATISTIC: AppRouteRecordRaw = {
  path: '/statistic',
  name: 'statistic',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.statistic',
    icon: 'icon-user-group',
    requiresAuth: true,
    order: 8,
  },
  children: [
    {
      path: '/station',
      name: '/station',
      component: () => import('@/views/statistic/station/index.vue'),
      meta: {
        locale: 'menu.statistic.station',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default STATISTIC;
